/**
 * Module-level state for the Cognito API token feature flag.
 *
 * This module provides a getter/setter pair so that the feature flag value
 * (synced from LaunchDarkly via a React hook) can be read by non-React code
 * such as axios interceptors and superagent helpers.
 */

let cognitoApiTokenEnabled = false;

export function isCognitoApiTokenEnabled(): boolean {
  return cognitoApiTokenEnabled;
}

export function setCognitoApiTokenEnabled(enabled: boolean): void {
  cognitoApiTokenEnabled = enabled;
}
